export default {
    BACKEND_URL: "https://api.joyfullminds.com",
    FRONTEND_URL: "https://joyfullminds.com",
}